import log from 'loglevel';
import copyNotification from '../common/utils/copy-notification';

const initializeButton = (button) => {
    const $button = $(button);

    copyNotification.initialize(button);

    $button.on('click', (event) => {
        event.preventDefault();

        const selector = $button.attr('data-target') ?? '';

        if (selector.length === 0) {
            log.error('Missing target for copy button.', $button);
            return;
        }

        const $target = $(selector);

        if ($target.length === 0) {
            log.error(`Could not find element "${selector}".`)
            return;
        }

        const text = $target.text().trim();

        navigator.clipboard.writeText(text);
    });
};

const initialize = () => {
    $('[data-copy-button]').each((_, button) => {
        initializeButton(button);
    });
};

export default {
    initialize,
};
